import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        sites: '=',
        classifiers: '='
    },
    template: `
        <div class="heading01 type01 ng-scope">
            <h1>{{ 'courses.External courses' | translate }}</h1>
            <ul class="actions01">
                <li><a class="btn add" ng-click="vm.addParticipation()">{{ 'courses.Add external participation' | translate }}</a></li>
                <li><a class="btn filter" ng-click="vm.showFilter = !vm.showFilter">{{ 'courses.Filter submissions' | translate }}</a></li>
            </ul>
        </div>
        <courses-participations-filter sites="vm.sites" list="vm.list" show-filter="vm.showFilter"/>
        <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
        <div class="well" ng-if="!vm.list.loading && vm.list.items.length">
            <pagination-tools list="vm.list"></pagination-tools>
            <table
                ng-init="vm.initBulk()"
                class="data01"
                datatable
                dt-options="vm.DATATABLES">
                <thead>
                    <tr role="row">
                        <th ng-class="vm.list.getSortClass('display_name')">
                            <span ng-click="vm.list.sortBy('display_name')">{{ 'participation.Employee' | translate }}</span>
                        </th>
                        <th ng-class="vm.list.getSortClass('course_name')">
                            <span ng-click="vm.list.sortBy('course_name')">{{ 'participation.Course' | translate }}</span>
                        </th>
                        <th ng-class="vm.list.getSortClass('start_time')">
                            <span ng-click="vm.list.sortBy('start_time')">{{ 'participation.Time of participation' | translate }}</span>
                        </th>
                        <th ng-class="vm.list.getSortClass('duration')">
                            <span ng-click="vm.list.sortBy('duration')">{{ 'training.Duration' | translate }}</span>
                        </th>
                        <th ng-class="vm.list.getSortClass('price')">
                            <span ng-click="vm.list.sortBy('price')">{{ 'courses.external.Cost' | translate }}</span>
                        </th>
                        <th ng-class="vm.list.getSortClass('expire_date')">
                            <span ng-click="vm.list.sortBy('expire_date')">{{ 'reports.Expire date' | translate }}</span>
                        </th>
                        <th ng-class="vm.list.getSortClass('status')">
                            <span ng-click="vm.list.sortBy('status')">{{ 'participation.Status' | translate }}</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="item in vm.list.items">
                        <td><a ui-sref="authorized.user.employee.detail({ id: item.user.id })">{{ item.user.displayName }}</a></td>
                        <td><a ui-sref="authorized.courses.participations.detail({ id: item.id })">{{ item.courseName }}</a></td>
                        <td>{{ vm.getTimeOfParticipation(item) }}</td>
                        <td>{{ vm.getDuration(item) }}</td>
                        <td>
                            {{ item.price }} {{ vm.COURSE_PRICE_TYPE_ENUM.LABELS[item.priceType] }}
                        </td>
                        <td ng-if="item.expireDate">{{ vm.MomentService.formatDate(item.expireDate) }}</td>
                        <td ng-if="!item.expireDate"></td>
                        <td>
                            <span ng-if="item.status===vm.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.CONFIRMED" class="tag color02">
                                {{ vm.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.LABELS[item.status].replace(' ', '&nbsp;') }}
                            </span>
                            <span ng-if="item.status!=vm.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.CONFIRMED &&
                                item.status!=vm.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.DECLINED" class="tag">
                                {{ vm.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.LABELS[item.status].replace(' ', '&nbsp;') }}
                            </span>
                            <span ng-if="item.status===vm.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.DECLINED" class="tag color01">
                                {{ vm.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.LABELS[item.status].replace(' ', '&nbsp;') }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <pagination list="vm.list"></pagination>
        </div>
    `
})
export default class {
    constructor (ListFactory, DATATABLES, COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM,
                 ExternalParticipationResource, MomentService, ModalService, lodash,
                 COURSE_DURATION_TYPE_ENUM, COURSE_PRICE_TYPE_ENUM, $translate) {
        this.ListFactory = ListFactory;
        this.DATATABLES = DATATABLES;
        this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM = COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM;
        this.COURSE_DURATION_TYPE_ENUM = COURSE_DURATION_TYPE_ENUM;
        this.COURSE_PRICE_TYPE_ENUM = COURSE_PRICE_TYPE_ENUM;
        this.ExternalParticipationResource = ExternalParticipationResource;
        this.MomentService = MomentService;
        this.ModalService = ModalService;
        this.lodash = lodash;
        this.$translate = $translate;

        this.format = 'DD-MM-YYYY HH:mm:ss';
    }

    $onInit () {
        this.list = this.ListFactory.createWithPagination(this.ExternalParticipationResource.query.bind(this.ExternalParticipationResource));
        this.list.pagination.perPage = 50;
        this.list.fetch({ expand: 'user,firstTime,lastTime,fields,courseDates,durationFormatted', isAdmin: true });
    }

    getDuration (item) {
        if (!item.duration) {
            return null;
        }
        return `${item.duration} ${this.COURSE_DURATION_TYPE_ENUM.SHORTEN[item.durationType ? item.durationType : 'HOURS']}`;
    }

    getTimeOfParticipation (item) {
        const startTime = item.firstTime ? this.MomentService.formatTimeStamp(item.firstTime.startTime, this.format, false) : '';
        const endTime = item.lastTime ? this.MomentService.formatTimeStamp(item.lastTime.endTime, this.format, false) : '';

        return `${startTime} - ${endTime}`;
    }

    addParticipation () {
        const { classifiers } = this;
        return this.ModalService.open({
            template: `
                <modals-courses-external-add-participation
                    class="wrapper"
                    classifiers="vm.classifiers"
                    uib-modal-instance="vm.$uibModalInstance"
                />
            `,
            size: 'xlarge',
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.classifiers = classifiers;
            }
        }).then(() => {
            this.list.fetch({ expand: 'user,firstTime,lastTime,fields,courseDates', isAdmin: true });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/participations/list/index.js